<template>
  <div>
    <!-- Add dialog component at the top level -->
    <v-dialog v-model="showJoinCallDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Join Ongoing Call
        </v-card-title>
        <v-card-text>
          <p>You are about to join an ongoing call. Please note the following:</p>
          <ul>
            <li>You will join as a Supervisor by default.</li>
            <li>You can listen to the call and communicate with staff, but not with customers.</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey-darken-1"
            variant="text"
            @click="showJoinCallDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="joinOngoingCallAsSupervisor"
          >
            Join Call
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="openFilter && !labpagestatus" style="flex: 10 10; position: relative">
        <AllFilter 
          :class="isMobile ? 'shared-overlay-mobile' : 'shared-overlay'" 
          v-model:type_selectedValues="type_selectedValues"
          :conTypes="contactTypes"
          v-model:tag_selectedValues="tag_selectedValues"
          :conTags="filteredTags"
          @apply-filter="filter_handle"
          @closeFilter="openFilter=false"
          :conversationTags="tags"  
          v-model:conversationTag_selectedValues="conversationTagFilter" 
          @conversation-tag-change="onConversationTagFilter"
          />

    </div>
     
  <v-card outlined style="height: 100%; display: flex; flex-direction: column">
        <div
        v-if=" (tag_selectedValues.length > 0 || type_selectedValues.length > 0 || (od_selectedValue && isFilterApplied))"
        class="filter-chip-truncated d-flex align-center"
      >
        <!-- OD filter -->
        <div v-if="od_selectedValue" class="chip-item mr-2">
          <v-icon :color="currentOdFilter?.color" size="18">mdi-{{ currentOdFilter?.icon }}</v-icon>
          <span class="ml-1">{{ od_selectedValue }}</span>
             <v-icon  v-if="od_selectedValue === 'lab-cases'&& labpagestatus" class="pulse-icon" color="secondary" @click="() => { loadLabs(); showLABfilter = !showLABfilter }">  mdi-filter-outline</v-icon>
           <v-icon  v-if="od_selectedValue === 'Pre-Auths'" class="pulse-icon" color="secondary" @click="() => { showPreAuthFilter = !showPreAuthFilter }">  mdi-filter-outline</v-icon>
        </div>
        <v-badge  v-if="labpagestatus && !loading && filterCalls.length"  :color="'#FB4141'" :content="filterCalls.length"></v-badge>
        <!-- Contact Tags -->
        <div v-if="tag_selectedValues.length > 0" class="chip-item mr-2">
           Contact Tag
          <span v-if="tag_selectedValues.length > 1" class="extra-count">+{{ tag_selectedValues.length }}</span>         
        </div>

        <!-- Contact Types -->
        <div v-if="type_selectedValues.length > 0" class="chip-item mr-2">
          Contact type
          <span v-if="type_selectedValues.length > 1" class="extra-count">+{{ type_selectedValues.length }}</span>          
        </div>

        <!-- Clear Filter Button -->
        <v-btn v-if="!labpagestatus && !loading" icon variant="text" color="red" size="28" class="m-1 rounded-md" @click="closePanelToall">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </div>   
    <v-card-subtitle v-if="isFilterApplied && od_selectedValue" style="opacity: 1; margin-bottom: 0%;">

           <!-- Pre-Auth Filter UI -->
        <v-card
          v-if="od_selectedValue === 'Pre-Auths' && showPreAuthFilter"
          elevation="2"  color="white"  class="mt-2 pa-2">
          <v-col>
            <v-select
              v-model="selectedCarrier"
              label="Search or Select Carrier"
              :items="carrierList"
              multiple
              variant="underlined"
              clearable
              :menu-props="{ maxHeight: 300 }"
              color="primary"
              @update:model-value="filterPreAuth"
            ></v-select>
          </v-col>
        </v-card>
               <!-- Lab Cases (Conditional) -->
        <v-card v-if="od_selectedValue === 'lab-cases' && showLABfilter "  elevation="2"  color="white"  class="mt-2 pa-2">
          <v-col >
            <v-select
              v-model="selectedLab"
              label="Search or Select Lab"
              :items="labs"
              item-value="lab_number"
              item-title="lab_name"
              multiple
              variant="underlined"
              style="min-width: 120px; cursor: pointer;"
              color="success"
              clearable
              :loading="loadingLabs"
              :menu-props="{ maxHeight: 300 }"
              @update:model-value="filterLabs"
            >
              <!-- Custom Item -->
              <template v-slot:item="{ item, props }">
                <div
                  v-bind="props"
                  :style="{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 8px',
                    cursor: 'pointer',
                    backgroundColor: selectedLab?.includes(item.value) ? '#DDEEFF' : 'transparent',
                  }"
                >
                  <v-icon size="15" class="mr-2" color="success">mdi-hospital-building</v-icon>
                  <span :style="{ textAlign: 'left', flex: 1 }">
                    {{ item.raw.lab_name }}
                  </span>
                </div>
              </template>

              <!-- Custom Selection -->
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index === selectedLab.length - 1"
                  label
                  small
                  closable
                  color="indigo-darken-1"
                  class="rounded-md"
                  @click:close="removeLabChip(item.value)"
                >
                  <span>{{ item.raw.lab_name }}</span>
                  <template v-slot:close>
                    <v-icon color="red" size="15">mdi-close</v-icon>
                  </template>
                </v-chip>

                <span v-if="index === selectedLab.length - 2" class="grey--text caption">
                  <v-chip label size="30" color="indigo-darken-1">
                    +{{ selectedLab.length - 1 }}
                  </v-chip>
                </span>
              </template>

              <!-- Infinite scroll -->
              <template v-slot:menu="{ props }">
                <v-list
                  v-bind="props"
                  style="max-height: 300px; overflow-y: auto;"
                 /><!-- @scroll.passive="onScroll" -->
              </template>
            </v-select>
          </v-col>
          </v-card>
    </v-card-subtitle>
       <!-- Search Field  -->
      <div style="margin-bottom: 13%; margin-top: 0%; padding: 10px; justify-content: space-around;">
        <v-text-field
          v-model="searchTerm"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          variant="underlined"
          style="width:auto ; max-height: 5px;"
        >
          <template v-slot:append v-if="!labpagestatus">
            <div @click="open_Filter()" style="cursor: pointer;">
              <v-icon v-if="!isFilterApplied" color="secondary">mdi-filter-outline</v-icon>
              <v-badge v-else :color="'#FB4141'" :content= "od_selectedValue === 'lab-cases'? statusCount(3):filterCalls.length">
                <v-icon color="secondary">mdi-filter-multiple</v-icon>
              </v-badge>
            </div>
          </template>
        </v-text-field>
      </div>
      <!--lab Action Buttons Status toolbar: only when od_selectedValue === 'lab-cases' -->
      <div v-if="labpagestatus && od_selectedValue === 'lab-cases' && isFilterApplied && can_manual_tagging " style="display: flex; flex-direction: row; align-items: center; width: 100%;">
        <div style="flex: 1 1 0; display: flex; padding: 10px; justify-content: space-around; align-items: center;">
            <!-- Status 1 -->
          <button
          :class="statusButtonClass(0)"  
          style="position: relative;"
          @click ="getlabconversation">
          <v-icon>mdi-forum-outline</v-icon>
          </button>
          <button
            :class="statusButtonClass(1)"
            @click="handleStatusClick(1)"
            title="Created -> Not Sent"
            style="position: relative;"
          >
            <v-icon :color="statusMap['1'].color">mdi-clipboard-text-off-outline</v-icon>
            <span v-if="clickedStatus === 1" class="status-badge">{{ statusCount(1) }}</span>
          </button>

          <!-- Status 2 -->
          <button
            :class="statusButtonClass(2)"
            @click="handleStatusClick(2)"
            title="Sent -> Not Received"
            style="position: relative;"
          >
            <v-icon :color="statusMap['2'].color">mdi-truck-delivery-outline</v-icon>
            <span v-if="clickedStatus === 2" class="status-badge">{{ statusCount(2) }}</span>
          </button>

          <!-- Status 3 -->
          <button
            :class="statusButtonClass(3)"
            @click="handleStatusClick(3)"
            title="Received -> Not Scheduled"
            style="position: relative;"
          >
            <v-icon :color="statusMap['3'].color">mdi-email-arrow-left-outline</v-icon>
            <span v-if="clickedStatus === 3" class="status-badge">{{ statusCount(3) }}</span>
          </button>

          <!-- Status 4 -->
          <button
            :class="statusButtonClass(4)"
            @click="handleStatusClick(4)"
            title="Appointment Scheduled"
            style="position: relative;"
          >
            <v-icon :color="statusMap['4'].color">mdi-calendar-range</v-icon>
            <span v-if="clickedStatus === 4" class="status-badge">{{ statusCount(4) }}</span>
  </button>
          <div class="relative w-12 h-12 flex items-center justify-center rounded-lg border cursor-pointer group">
              <v-icon v-if="!expanded" color="primary" large @click="expand" >
                mdi-bell
              </v-icon>
              <div v-else class="absolute inset-0 flex rounded-lg overflow-hidden border">
                      <v-icon @click="changePanelToTOday" color="primary">mdi-bell</v-icon>
                      <v-icon  @click="changePanelToLater" color="primary">mdi-bell-plus</v-icon>
              </div>
            </div>
          <!-- Unknown / apt completed  -->
          <!-- <button
            :class="statusButtonClass(0)"
            @click="handleStatusClick(0)"
            title=""
          >
        <v-icon color="purple">mdi-flask</v-icon>
       <v-tooltip activator="parent" location="bottom"></v-tooltip> 
        </button>  -->
          <!-- Clear filter quick button -->
    
          <!-- <button
            v-if="activeStatusFilter !== null"
            @click="handleStatusClick(null)"
            style="margin: 5px; border: solid 1px black; height: fit-content; border-radius: 7px; background: transparent;"
            title="Clear status filter"
          >
            <v-icon color="primary">mdi-close</v-icon> -->
            <!-- <v-tooltip activator="parent" location="bottom">Clear Status Filter</v-tooltip> -->
          <!-- </button> -->
         
          </div>
   </div>
      
      <!-- Action Buttons -->
      <div v-else-if="!labpagestatus" class="action-buttons-container">
  <div class="action-buttons-wrapper">
    <button
      @click="showOngoingCalls = !showOngoingCalls"
      class="action-button"
      :class="{ 'active': showOngoingCalls }"
    >
      <v-icon :color="showOngoingCalls ? 'green' : 'grey'">mdi-phone-in-talk</v-icon>
      <v-tooltip activator="parent" location="bottom">{{ showOngoingCalls ? 'Hide ongoing calls' : 'Show ongoing calls' }}</v-tooltip>
    </button>
    <button
      @click="toggleAIValidation"
      class="action-button"
      :class="{ 'active': showAIValidation }"
    >
      <v-icon :color="showAIValidation ? '#6366f1' : 'grey'">mdi-robot-outline</v-icon>
      <v-tooltip activator="parent" location="bottom">{{ showAIValidation ? 'Hide AI Contacts' : 'AI New Patient Contacts (7 days)' }}</v-tooltip>
    </button>
    <SchedulingFilter style="display: flexbox; justify-content: space-around" ref="filterComp" :disabled="loading" v-model="filters" @filterChange="onFilterChange" class="scheduling-filter" />
    <button v-if="isAdmin" @click="showODFilterManager = true" style="background:none;border:none;cursor:pointer;padding:4px 2px;display:flex;align-items:center;">
      <v-icon size="18" color="grey">mdi-cog-outline</v-icon>
      <v-tooltip activator="parent" location="bottom">Manage OD Filters</v-tooltip>
    </button>
    <button v-if="od_selectedValue && activeODFilterId" @click="toggleRunsView"
      style="background:none;border:none;cursor:pointer;padding:4px 2px;display:flex;align-items:center;">
      <v-icon size="18" :color="viewMode !== 'live' ? 'primary' : 'grey'">mdi-history</v-icon>
      <v-tooltip activator="parent" location="bottom">Campaign Run History</v-tooltip>
    </button>
    <ODFilterManager v-if="showODFilterManager" @close="showODFilterManager = false" />
    <button 
      v-if="isFilterApplied && can_manual_tagging && filterCalls.length"
      @click="toggleApplyMassTag" 
      class="action-button"
    >
      <v-icon color="primary">mdi-tag-plus</v-icon>
      <v-tooltip activator="parent" location="bottom">Apply Tag</v-tooltip>
    </button>

    <!-- <button  style="margin: 5px; border: solid 1px black; height: fit-content; border-radius: 7px;"
     @click ="getlabconversation">
      <v-icon color="primary"> mdi-forum-outline</v-icon>
       <v-tooltip activator="parent" location="bottom">Lab conversation</v-tooltip>
    </button> -->
<div
  class="relative w-12 h-12 flex items-center justify-center rounded-lg border cursor-pointer group"
>
  <!-- Collapsed state -->
  <v-tooltip v-if="!expanded" location="bottom">
    <template v-slot:activator="{ props }">
      <v-icon
        v-bind="props"
        color="primary"
        size="28"
        @click="expand"
        class="transition-colors group-hover:text-blue-600"
      >
        mdi-bell
      </v-icon>
    </template>
    Today & Later
  </v-tooltip>

  <!-- Expanded state -->
  <div
    v-else
    class="absolute inset-0 flex items-center justify-around rounded-lg overflow-hidden border bg-white"
  >
    <!-- Today -->
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <v-icon
          v-bind="props"
          @click="changePanelToTOday"
          color="primary"
          size="28"
          class="cursor-pointer transition-colors hover:text-blue-600"
        >
          mdi-bell
        </v-icon>
      </template>
      Today
    </v-tooltip>

    <!-- Later -->
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <v-icon
          v-bind="props"
          @click="changePanelToLater"
          color="primary"
          size="28"
          class="cursor-pointer transition-colors hover:text-blue-600"
        >
          mdi-bell-plus
        </v-icon>
      </template>
      Later
    </v-tooltip>
  </div>
</div>


  </div>
</div>


      <div v-if="enable_selection" style="display: flex;padding: 5px; margin-top: -10%; margin-bottom: -10%; justify-content: space-around;">
        <v-checkbox label="Select All" @click="selectAllContacts"></v-checkbox>
      </div>

      <!-- ── Run details dialog (SQL / templates / tag / schedule snapshot) ─ -->
      <v-dialog v-model="snapshotDialog" max-width="640">
        <v-card>
          <v-card-title class="d-flex align-center py-3 px-4">
            <v-icon class="me-2" color="primary">mdi-file-search-outline</v-icon>
            Run Details
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto;">
            <div v-if="snapshotLoading" class="d-flex justify-center py-4">
              <v-progress-circular indeterminate size="24" />
            </div>
            <v-alert v-else-if="!runSnapshot" type="info" variant="tonal">
              No snapshot was recorded for this run.
            </v-alert>
            <div v-else>
              <div class="d-flex align-center gap-2 mb-3">
                <v-chip size="small" label color="primary" variant="tonal">{{ runSnapshot.filter_name || 'Custom query' }}</v-chip>
                <v-chip size="small" label>{{ runSnapshot.resolved_contact_count ?? runSnapshot.contact_count }} resolved</v-chip>
                <v-chip size="small">{{ runContacts.length }} messaged</v-chip>
              </div>

              <div class="text-caption text-medium-emphasis mb-1">SQL Query</div>
              <v-textarea
                v-if="runSnapshot.sql_query"
                :model-value="runSnapshot.sql_query"
                readonly variant="outlined" density="compact" rows="6"
                style="font-family: monospace; font-size: 12px" class="mb-3"
              />
              <v-alert v-else type="info" variant="tonal" density="compact" class="mb-3">
                {{ runSnapshot.execution_mode === 'recalls_api' ? 'This filter used the Recalls API — no SQL involved.' : 'Not applicable for this filter.' }}
              </v-alert>

              <template v-if="runSnapshot.enable_email">
                <div class="text-caption text-medium-emphasis mb-1">Email Subject</div>
                <div class="text-body-2 mb-2">{{ runSnapshot.email_subject || '—' }}</div>
                <div class="text-caption text-medium-emphasis mb-1">Email Template</div>
                <v-textarea
                  :model-value="runSnapshot.email_template"
                  readonly variant="outlined" density="compact" rows="4"
                  style="font-family: monospace; font-size: 12px" class="mb-3"
                />
              </template>

              <template v-if="runSnapshot.enable_sms">
                <div class="text-caption text-medium-emphasis mb-1">SMS Template</div>
                <v-textarea
                  :model-value="runSnapshot.sms_template"
                  readonly variant="outlined" density="compact" rows="3"
                  style="font-family: monospace; font-size: 12px" class="mb-3"
                />
              </template>

              <div class="d-flex align-center gap-2">
                <v-icon size="14" color="grey">mdi-tag-outline</v-icon>
                <span class="text-caption">{{ snapshotTagName(runSnapshot.tag_id) || 'No tag' }}</span>
                <v-divider vertical style="height:14px" />
                <v-icon size="14" color="grey">mdi-clock-outline</v-icon>
                <span class="text-caption">{{ snapshotScheduleDescription(runSnapshot.schedule_config) }}</span>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="px-4 py-3">
            <v-spacer />
            <v-btn variant="text" @click="snapshotDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ── Campaign Runs list ──────────────────────────────────────────── -->
      <div v-if="viewMode === 'runs'" style="flex: 1 1 100px; overflow-y: auto; padding: 8px 4px;">
        <div v-if="runsLoading" class="text-center py-6">
          <v-progress-circular indeterminate size="24" />
        </div>
        <div v-else-if="!runsList.length" class="text-caption text-center py-6" style="color:#757575">
          No campaign runs yet for this filter.
        </div>
        <div v-else-if="totalBooked > 0" class="text-caption text-medium-emphasis mb-2 d-flex align-center gap-1">
          <v-icon size="14" color="success">mdi-calendar-check</v-icon>
          {{ totalBooked }} appointment{{ totalBooked === 1 ? '' : 's' }} booked across all runs
        </div>
        <v-card
          v-for="run in runsList"
          :key="run.execution_id"
          class="mb-2 pa-3 cursor-pointer"
          variant="outlined"
          hover
          @click="openRun(run)"
        >
          <div class="d-flex align-center gap-2">
            <v-icon size="18" color="grey">mdi-calendar-check-outline</v-icon>
            <span class="text-body-2 font-weight-medium">
              {{ run.sent_at ? new Date(Number(run.sent_at)).toLocaleString() : 'Unknown date' }}
            </span>
            <v-spacer />
            <v-chip size="x-small" color="primary" label>{{ run.contacts }} contacts</v-chip>
          </div>
          <div
            v-for="ch in run.channels"
            :key="ch.channel"
            class="d-flex align-center gap-1 mt-1"
          >
            <v-icon size="14" :color="ch.channel === 'email' ? 'blue-grey' : 'teal'">
              {{ ch.channel === 'email' ? 'mdi-email-outline' : 'mdi-message-text-outline' }}
            </v-icon>
            <v-chip size="x-small" label color="success">{{ ch.sent_count }} sent</v-chip>
            <v-chip v-if="ch.failed_count > 0" size="x-small" label color="error">{{ ch.failed_count }} failed</v-chip>
            <v-chip v-if="ch.opened_count > 0" size="x-small" label color="purple" prepend-icon="mdi-email-open-outline">{{ ch.opened_count }} opened</v-chip>
          </div>
          <div v-if="run.booked_count > 0" class="d-flex align-center gap-1 mt-1">
            <v-chip size="x-small" label color="success" prepend-icon="mdi-calendar-check">{{ run.booked_count }} booked</v-chip>
          </div>
        </v-card>
      </div>

      <!-- ── Campaign Run detail header (run picker stays run-specific; the
           contact list itself is shared with the live/Unattended view below,
           same order + row format) ─────────────────────────────────────── -->
      <div v-else-if="viewMode === 'runDetail'" class="d-flex align-center pa-2 mb-1">
        <v-btn icon size="x-small" variant="text" @click="backToRuns">
          <v-icon size="16">mdi-arrow-left</v-icon>
        </v-btn>
        <span class="text-caption ml-1">
          Run: {{ activeRun?.sent_at ? new Date(Number(activeRun.sent_at)).toLocaleString() : '' }}
        </span>
        <v-spacer />
        <v-btn
          v-if="activeRun"
          size="x-small" variant="text" color="primary"
          prepend-icon="mdi-file-search-outline"
          @click="openRunSnapshot(activeRun)">
          View details
        </v-btn>
      </div>

      <!-- ── Contact list: shared between live/Unattended and campaign run detail ── -->
      <template v-if="viewMode !== 'runs'">
      <div v-if="viewMode === 'runDetail' && runContactsLoading" class="text-center py-4">
        <v-progress-circular indeterminate size="20" />
      </div>
      <div v-else-if="viewMode === 'runDetail' && !groupedRunContacts.length" class="text-caption text-center py-4" style="color:#757575">
        No contacts found for this run.
      </div>
      <div v-else-if="viewMode === 'live' && !loading && !filterCalls.length" class="text-caption text-center" style="color: #757575">
        No calls or messages found
      </div>

      <template v-if="viewMode === 'live' && loading">
        <v-progress-linear indeterminate color="deep-purple-accent-4"></v-progress-linear>
      </template>

      <RecycleScroller
          :items="activeScrollerItems"
          :item-size="62"
          key-field="seqId"
          v-slot="{ item }"
          style="flex: 1 1 100px; overflow-y: auto; overflow-x: hidden"
          @scroll="handleScroll"
        >
          <v-hover>
            <template v-slot:default="{ isHovering, props: hoverProps }">
              <div v-if="item.isHeader"
                class="ongoing-calls-header text-subtitle-2 font-weight-medium ongoing-call"
                style="padding: 12px 16px; margin-bottom: 0; border-radius: 4px 4px 0 0;">
                <v-icon size="small" color="success" class="mr-2">mdi-phone-in-talk</v-icon>
                {{ item.headerText }}
              </div>

              <div v-else v-bind="hoverProps"
                @click="selectContact(item.contact_id, item)"
                :class="{
                  highlighted: current_contact.contact_id == item.contact_id || selected_contacts.includes(item.contact_id) && isFilterApplied,
                  hovered: isHovering && current_contact.contact_id !== item.contact_id && !enable_selection,
                  'ongoing-call': item.isOngoing
                }"
                style="display: flex; align-items: center; justify-content: space-between; height: 62px;"
                class="unselectable" :id="item.contact_id">

                <div style="flex: 1 1 1; display: flex; align-items: center;" class="ml-2">
                  <div style="flex: 1 1 1;">
                    <template v-if="item.isOngoing">
                      <div style="display: flex; flex-direction: row-reverse; flex-wrap: nowrap; justify-content: end; align-items: center; max-width: 120px;">
                        <!-- Participants -->  
                        <div v-for="participant in item.participants" :key="participant.user_id || participant.contact_id" style="flex: 1 1 1; margin-left: -6px;">
                          <template v-if="participant.user_id">
                            <UserPopup dense :user_id="participant.user_id" :tooltip="true" :showProfile="false" size="small" />
                          </template>
                          <template v-else-if="participant.contact_id">
                            <ContactPopup dense :contact_id="participant.contact_id" :tooltip="true" :showProfile="false" size="small" />
                          </template>
                        </div>
                      </div>
                    </template>

                    <template v-else-if="item.contact_id">
                      <ContactPopup dense :contact_id="item.contact_id" :tooltip="true" :showProfile="false" />
                    </template>

                    <template v-else>
                      <v-tooltip location="top" text="Add number to contact">
                        <template v-slot:activator="{ props }">
                          <v-btn v-bind="props" icon variant="text" size="x-small">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                    </template>
                  </div>

                  <div style="flex: 1 1 1; display: flex; flex-direction: column;" class="ml-2">
                    <div style="flex: 1 1 1; line-height: 1.25rem; font-size: 15px; white-space: nowrap;">
                      {{ formattedName(item) }}
                    </div>

<div style="flex: 1 1 1; display: flex; line-height: 1rem; color: #757575;" class="text-caption">
  <div style="flex: 1 1 1;" class="mr-1">
    <v-tooltip
      location="right"
      :text="item.isOngoing ? item.tooltip_text : item.is_reminder_due ? reminderTooltip(item) : item.isCampaignRun ? campaignTooltip(item) : calcTooltip(item)"
    >
      <!--  Activator MUST be first -->
      <template #activator="{ props }">

        <!--  Conversation Tag Filter -->
        <v-icon
          v-if="conversationTagFilter.length && getLeftPanelIcon(item)"
          v-bind="props"
          size="small"
          :color="getLeftPanelIcon(item).color"
        >
          {{ getLeftPanelIcon(item).icon }}
        </v-icon>

        <!--  Normal flow -->
        <template v-else>
          <v-icon v-bind="props" size="small" v-if="item.is_reminder_due" color="deep-orange">
            mdi-bell-ring
          </v-icon>

          <v-icon v-bind="props" size="small" v-else-if="item.isCampaignRun && item.booked_at" color="success">
            mdi-calendar-check
          </v-icon>

          <v-icon v-bind="props" size="small" v-else-if="item.isCampaignRun"
            :color="item.campaignStatus === 'failed' ? 'red' : item.campaignStatus === 'opened' ? 'purple' : 'green'">
            {{ item.campaignStatus === 'failed' ? 'mdi-message-alert' : item.campaignStatus === 'opened' ? 'mdi-email-open-outline' : 'mdi-check-circle-outline' }}
          </v-icon>

          <v-icon v-bind="props" size="small" v-else-if="item.isOngoing" color="success">
            mdi-phone-in-talk
          </v-icon>

          <v-icon v-bind="props" size="small" color="red"
            v-else-if="item.call_status === 1 || item.call_missed === 1">
            mdi-phone-missed
          </v-icon>

          <v-icon v-bind="props" size="small" color="primary"
            v-else-if="item.call_status === 3 || item.call_missed === 3">
            mdi-phone-incoming
          </v-icon>

          <v-icon v-bind="props" size="small"
            v-else-if="item.comm_direction === 'incoming'"
            color="red"
          >
            mdi-message-outline
          </v-icon>

          <v-icon v-bind="props" size="small"
            v-else-if="item.comm_direction === 'outgoing'
              || item.comm_direction === 'queued'
              || item.comm_direction === 'delivered'"
            color="primary"
          >
            mdi-message-outline
          </v-icon>

          <v-icon v-bind="props" size="small"
            v-else-if="item.comm_direction === 'failed'
              || item.comm_direction === 'undelivered'
              || item.comm_direction === 'rejected'"
            color="red"
          >
            mdi-message-alert
          </v-icon>

          <v-icon v-bind="props" size="small" color="primary"
            v-else-if="item.comm_direction === 'outbound'">
            mdi-phone-outgoing
          </v-icon>

          <v-icon v-bind="props" size="small"
            v-else-if="item.comm_direction === 'sent'"
            color="primary"
          >
            mdi-email-outline
          </v-icon>

          <v-icon v-bind="props" size="small"
            v-else-if="item.comm_direction === 'received'"
            color="red"
          >
            mdi-email-outline
          </v-icon>

          <!-- OD icons -->
          <v-icon
            v-else-if="item.comm_direction == -1 && item.call_status == -1 && isFilterApplied"
            v-bind="props"
            size="small"
            :color="od_selectedValue === 'lab-cases'
              ? getstatus(item.contact_id)
              : currentOdFilter?.color"
          >
            {{
              od_selectedValue === 'lab-cases'
                ? getStatusIcon(item.contact_id)
                : `mdi-${currentOdFilter?.icon}`
            }}
          </v-icon>

        </template>
      </template>
    </v-tooltip>
  </div>

  <!--  DATE IS CORRECT -->
  <div style="flex: 1 1 1">
    {{ simpleDateFormat(item.date) }}
  </div>
</div>

                  <!-- Note attached to the tagged message (conversation-tag-filtered views only, e.g. Unattended) -->
                  <div v-if="item.message_note" style="flex: 1 1 1; display: flex; align-items: center; color: #2979FF; margin-top: 2px;" class="text-caption">
                    <v-tooltip location="right" :text="item.message_note">
                      <template #activator="{ props }">
                        <v-icon v-bind="props" size="small" color="#2979FF" class="mr-1">mdi-note-text</v-icon>
                        <span v-bind="props" class="text-truncate font-weight-medium" style="max-width: 180px; display: inline-block;">{{ item.message_note }}</span>
                      </template>
                    </v-tooltip>
                  </div>

                  </div>
                </div>

                <div v-if="isHovering || current_contact.contact_id == item.contact_id" style="flex: 1 1 1; display: flex; align-items: center;" class="mr-2">
                  <div style="grid-area: 1/1/1/1; justify-self: end;">
                    <div style="display: inline-flex; vertical-align: middle;">
                      <template v-if="item.isOngoing">
                        <v-btn variant="text" style="min-width: 40px; height: 25px;" @click.stop="joinOngoingCall(item)">Join</v-btn>
                      </template>

                       <!-- cell phone button / endpoint button -->
                      <v-tooltip v-if="item.ph1 && item.ph1" location="bottom" :text="phoneFormat(item.ph1)">
                        <template v-slot:activator="{ props }">
                          <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon @click="phoneCall(item.first_name, item.ph1)">
                            <v-icon size="small" color="green">mdi-cellphone</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                       <!-- home phone button -->
                      <v-tooltip v-if="item.ph2 && item.ph2" location="bottom" :text="phoneFormat(item.ph2)">
                        <template v-slot:activator="{ props }">
                          <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon @click="phoneCall(item.first_name, item.ph2)">
                            <v-icon size="small" color="green">mdi-home</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                      <!-- work phone button -->
                      <v-tooltip v-if="item.ph3 && item.ph3" location="bottom" :text="phoneFormat(item.ph3)">
                        <template v-slot:activator="{ props }">
                          <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon @click="phoneCall(item.first_name, item.ph3)">
                            <v-icon size="small" color="green">mdi-briefcase</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>

                    <v-tooltip v-if="item.phone_num && item.phone_num" location="bottom"
                      :text="phoneFormat(item.phone_num)">
                      <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon
                        @click="phoneCall(item.first_name, item.phone_num)">
                        <v-icon size="small" color="green">mdi-phone</v-icon>
                      </v-btn>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="item.email && item.email.length > 0" location="bottom" :text="item.email">
                      <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon>
                        <v-icon size="small" color="green">mdi-email</v-icon>
                      </v-btn>
                      </template>
                    </v-tooltip>
                     <!-- tag button -->
                     <v-tooltip v-if="item.tag_id && item.tag_id.length > 0" location="bottom" :array="getTagNames(item.tag_id)">
                      <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" variant="text" style="width: 25px;height: 25px;" icon>
                          <v-icon size="small" color="green">mdi-tag</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:default>
                        <div v-for="tagName in getTagNames(item.tag_id)" :key="tagName">
                          <p>{{ tagName }}</p>
                        </div>
                      </template>                      
                    </v-tooltip>                  
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-hover>
      </RecycleScroller>
      </template><!-- end shared contact list (live + runDetail) -->
      <div v-if="selected_contacts.length" class="text-end">
        <v-dialog max-width="500">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              size="35"
              icon
              color="success"
              class="heartbeat"
              :class="{'mass-tag-mobile' : isMobile, 'mass-tag-window' : !isMobile}"
            >
              <v-icon>mdi-tag-check</v-icon>
            </v-btn>
          </template>
        
          <template v-slot:default="{ isActive }">
            <v-card rounded="lg">
              <v-card-title class="d-flex justify-space-between align-center">
                <div class="text-medium-emphasis ps-2">
                  Select Tags
                </div>
                <v-btn
                  icon="mdi-close"
                  variant="text"
                  @click="toggleApplyMassTag()"
                ></v-btn>
              </v-card-title>
            
              <v-divider class="mb-4"></v-divider>

              <v-card-text>
                <v-chip-group v-model="selectedTags" column multiple>
                  <v-chip
                    v-for="item in tags"
                    :key="item.tag_id"
                    :value="item.tag_id"
                    variant="outlined"
                    filter
                    :color="item.tag_color"
                  >
                    <v-icon :color="item.tag_color">mdi-{{ item.tag_icon }}</v-icon>
                    {{ item.tag_name }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            
              <v-divider class="mt-2"></v-divider>
            
              <v-card-actions class="my-2 d-flex justify-end">
                <v-btn
                  class="text-none"
                  rounded="xl"
                  text="Cancel"
                  @click="toggleApplyMassTag()"
                ></v-btn>
              
                <v-btn
                  class="text-none"
                  color="success"
                  rounded="xl"
                  text="Apply"
                  variant="flat"
                  :disabled="!selectedTags.length"
                  @click="isActive.value = false ; applyMassTag(selectedTags)"
                ></v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </div>
  </v-card>
</div>
</template>

<script>
import ContactPopup from "@/components/Avatar/ContactPopup";
import UserPopup from "@/components/Avatar/UserPopup";
import dayjsMixin from "@/mixins/dayjsMixin";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EventBus from "@/eventBus";
import { phoneFormat } from "@/util/util";
import ConvoService from "@/services/convoService";
import AllFilter from "./AllFilter.vue";
import AiButton from '../UIComponents/AiButton.vue';
import OdService from "../../services/odService";
import SchedulingFilter from "../SchedulingFilter.vue"
import aiValidationService from "@/services/aiValidationService"
import ODFilterManager from "./ODFilterManager.vue"
export default {
  name: "LeftPanel",
  components: { ContactPopup, UserPopup, AllFilter, AiButton, SchedulingFilter, ODFilterManager },
  mixins: [dayjsMixin],
  data() {
    return {
      searchTerm: "",
      checkboxpriority: 0,
       filters: [],
      checkboxall: 1,
      allcontactTypes: [],
      type_selectedValues: [],
      combinedData: [],
      showCreateTagDialog: false,
      tag_selectedValues: [],
      selectedTags: [],
      od_selectedValue: null,
      showODFilterManager: false,
      selectedItem: null,
      openFilter: false,
      enable_selection: false,
      selected_contacts: [],
      select_AllContacts: false,
      showOngoingCalls: false,
      showAIValidation: false,
      isBottom: false,
      showJoinCallDialog: false,
      selectedCall: null,
      //updateCall: 0,
      activeStatusFilter: null, 
      expanded:false,
      statusMap: {
        "1": { color: "orange darken-2", icon: "mdi-clipboard-text-off-outline", text: "Not Sent to Lab" },
        "2": { color: "blue darken-2", icon: "mdi-truck-delivery-outline", text: "Sent to Lab" },
        "3": { color: "green darken-2", icon: "mdi-email-arrow-left-outline", text: "Completed Lab Work" },
        "4": { color: "teal darken-2", icon: "mdi-calendar-range", text: "Appointment Scheduled" },
      },
      clickedStatus: null,
      selectedLabs: [],   
      filteredCalls: [],
      showLABfilter:false,
       labs: [],
    selectedLab: [],
    selectedStatus: [], 
    loadingLabs: false,
    hasLabNameFilter:false,
    Schedulefilter:false,
    showPreAuthFilter: false,
    selectedCarrier: [],
    carrierList: [],
    conversationTagFilter: [],
    // Campaign runs view
    viewMode: 'live',        // 'live' | 'runs' | 'runDetail'
    runsList: [],
    runsLoading: false,
    activeRun: null,
    runContacts: [],
    runContactsLoading: false,
    snapshotDialog: false,
    snapshotLoading: false,
    runSnapshot: null,
    };
  },
  computed: {
    activeODFilterId() {
      if (!this.od_selectedValue) return null;
      const f = (this.odFilterList || []).find(f => f.filter_name === this.od_selectedValue);
      return f ? f.id : null;
    },
    currentOdFilter() {
      if (!this.od_selectedValue) return null;
      return (this.odFilterList || []).find(f => f.filter_name === this.od_selectedValue) || null;
    },
    // Sum of each run's booked_count. Safe to sum because the backend's matching is
    // last-touch/mutually-exclusive per contact — the same physical appointment can
    // never be counted in more than one run's booked_count.
    totalBooked() {
      return (this.runsList || []).reduce((sum, run) => sum + (Number(run.booked_count) || 0), 0);
    },
    // Campaign run contacts, reshaped to the same item shape scrollerCalls
    // produces (contact_id/first_name/last_name/ph1/email/tag_id/date) so the
    // run-detail view can render through the exact same RecycleScroller row
    // template as the live/Unattended list, and sorted the same way: most
    // recent conversation activity first (falling back to the campaign send
    // time for contacts with no other activity loaded).
    groupedRunContacts() {
      const map = new Map();
      for (const row of this.runContacts) {
        if (!map.has(row.contact_id)) {
          map.set(row.contact_id, {
            contact_id: row.contact_id,
            first_name: row.first_name,
            last_name: row.last_name,
            email: row.email,
            ph1: row.ph1,
            ph2: null,
            ph3: null,
            phone_num: null,
            tag_id: this.contactsHash?.[row.contact_id]?.tags || [],
            channels: [],
            isCampaignRun: true,
            seqId: `run-${row.contact_id}`,
            booked_at: row.booked_at || null,
            appt_date: row.appt_date || null,
          });
        }
        map.get(row.contact_id).channels.push({
          channel: row.channel,
          status: row.status,
          opened_at: row.opened_at,
          sent_at: row.sent_at
        });
      }

      const items = [...map.values()].map(entry => {
        const sentTimes = entry.channels.map(c => Number(c.sent_at)).filter(Boolean);
        const campaignSentAt = sentTimes.length ? Math.min(...sentTimes) : null;
        const recentActivity = this.left_panel_contacts.find(c => c.contact_id === entry.contact_id)?.date;

        entry.date = recentActivity || campaignSentAt;
        entry._sortDate = recentActivity ? Number(new Date(recentActivity)) : (campaignSentAt || 0);

        const hasFailed = entry.channels.some(c => c.status === 'failed');
        const hasOpened = entry.channels.some(c => c.opened_at);
        entry.campaignStatus = hasFailed ? 'failed' : hasOpened ? 'opened' : 'sent';

        return entry;
      });

      return items.sort((a, b) => b._sortDate - a._sortDate);
    },
    // Whichever contact list the RecycleScroller should currently render.
    activeScrollerItems() {
      return this.viewMode === 'runDetail' ? this.groupedRunContacts : this.scrollerCalls;
    },
    ...mapGetters('labcases', ['labpagestatus']),
    ...mapGetters("frontdesk", [
      "left_panel_contacts",
      "current_contact",
      "get_AllContact_Typesdata",
      "contactByCall",
      "loading",
      "fd_contacts",
      "get_alltags_data",
      "odFilterSelectedValue",
      "getOdTag",
      "isODFilterContact",
      "odFilterList",
       "odData",
       "getAllConversations"
    ]),
    ...mapGetters(["userId", "isAdmin"]),
    ...mapState("frontdesk", ["allConversations", "alltags_data"]),
    ...mapGetters("people", ["contactName", "contactsHash", "contactTypes", "getFamilyMembers", "getHeaderInfo"]),
    ...mapActions("people", ["getContactTypes"]),
    ...mapGetters("tags", ["tags", "tagsHash", "can_manual_tagging"]),
    ...mapActions("tags", ["getTags"]),
    ...mapGetters("window", ["isMobile"]),
    ...mapGetters("plivo", ["getOngoingCalls"]),
    ...mapGetters("osclaims",["_process","claims"]),
    ongoingCalls() {
      return this.getOngoingCalls;
    },

    // the calls to display in the current tab 
    filterCalls() {
      let filteredCalls = [];
      if (!this.checkboxpriority && this.checkboxall) {
        filteredCalls = this.textSearch(this.left_panel_contacts);
      } else if (this.checkboxpriority && !this.checkboxall) {
        for (let c in this.left_panel_contacts) {
          let item = this.left_panel_contacts[c];
          if (item.comm_direction && item.comm_direction === "incoming") {
            filteredCalls.push(item);
          } else if (typeof item.call_missed != "undefined" && item.call_missed === 1) {
            filteredCalls.push(item);
          } else if (typeof item.call_status != "undefined" && item.call_status === 1) {
            filteredCalls.push(item);
          }
        }
        filteredCalls = this.textSearch(filteredCalls) || [];
      };
        //  Apply lab Name filter
    if (this.selectedLabs && this.selectedLabs.length > 0) {
      const labNumbers = this.selectedLabs.map(l => Number(l.lab_number));
      filteredCalls = filteredCalls.filter(call => {
        if (call.od_json && call.od_json.length > 0) {
          return call.od_json.some(lab => labNumbers.includes(Number(lab.Lab_Num)));
        }
        return false;
      });
    };
     // Apply lab status filter 
  if (this.selectedStatus && this.selectedStatus.length > 0) {
    const statuses = this.selectedStatus.map(s => s.toLowerCase());
    filteredCalls = filteredCalls.filter(call => {
      return statuses.includes((call.call_status_name || "").toLowerCase());
    });
  };
  if (this.selectedCarrier.length && this.od_selectedValue === "Pre-Auths") {

    filteredCalls = filteredCalls.filter(call => {

      let matchFromOD = false;
      let matchFromClaims = false;

      if (call.od_json && Array.isArray(call.od_json)) {
        matchFromOD = call.od_json.some(j =>
          this.selectedCarrier.includes(j.CarrierName)
        );
      }

      const claim = (this.claims || []).find(c =>
        c.client_id == call.contact_id &&
        this.selectedCarrier.includes(c.Carrier)
      );

      matchFromClaims = !!claim;

      return matchFromOD || matchFromClaims;
    });

    }
      // Ensure all filtered calls have a seqId
      const filteredCallsWithSeqId = (filteredCalls || []).map((call, index) => ({
        ...call,
        seqId: call.seqId || `filtered-${call.contact_id}-${index}`
      }));
      return filteredCallsWithSeqId;
    },

    // Combined list shown by RecycleScroller.
    scrollerCalls() {
      let calls = [];

      if (this.showOngoingCalls) {
        const ongoingCallsWithoutCurrentUser = this.ongoingCalls
          ? this.ongoingCalls.filter(call => {
            if (!Array.isArray(call.participants) || call.participants.length === 0 || call.participants.length === 1) return false;
            return !call.participants.some(participant => participant.user_id === this.userId);
          })
          : [];

        if (ongoingCallsWithoutCurrentUser.length > 0) {
          calls.push({
            isHeader: true,
            headerText: `Ongoing Calls (${ongoingCallsWithoutCurrentUser.length})`,
            seqId: 'ongoing-header'
          });
          calls.push(
            ...ongoingCallsWithoutCurrentUser.map(call => ({
              ...call,
              isOngoing: true,
              comm_direction: call.comm_direction || 'ongoing',
              first_name: call.displayName || 'Conference',
              contact_id: call.contact_id,
              date: call.timestamp,
              seqId: `ongoing-${call.call_uuid}`,
              tooltip_text: this.formatDirection(call.comm_direction || 'ongoing')
            }))
          );
        }
      }

      // FILTER APPLIED: only apply for lab-cases (od_selectedValue)
      let filtered = [...this.filterCalls];

      if (this.od_selectedValue === 'lab-cases' && this.activeStatusFilter !== null) {
        filtered = filtered.filter(call => {
          const status = this.contactStatus(call.contact_id); 
          if (this.activeStatusFilter === 0) {
            return status === null || typeof status === 'undefined' || status.length === 0;
          }
          return Array.isArray(status)? status.includes(Number(this.activeStatusFilter)): Number(status) === Number(this.activeStatusFilter);
        });
      }

      calls.push(...filtered);
      return calls;
    },

    console: () => console,
    window: () => window,
    isFilterApplied() {
      return (this.type_selectedValues.length || this.tag_selectedValues.length || this.conversationTagFilter.length ||this.od_selectedValue);
    },
    filteredTags() {
      // Contact Tags filter dropdown: show every tag not explicitly hidden from
      // pickers (same `unlist` flag FDMessenger.vue's manual-tag picker respects).
      // Previously excluded any tag with no user_id, which meant every system-default
      // tag (Re-Care, Post-Ops, Pending-Treatment, Missed-Opportunity, ...) was
      // invisible here — those are all created with user_id: null (tag.controller.js's
      // addSystemDefaultTags) but are exactly the tags users want to filter by.
      return this.tags.filter(tag => !tag.unlist);
    }
  },

  watch: {
    od_selectedValue(val) {
      // Keep Vuex store in sync immediately so FDMessengerBox/FDMessenger/EmailMessage
      // can read the correct odFilterSelectedValue at any time (not just after getODdata completes)
      this.$store.commit('frontdesk/odSelected_value', val || null);

      // Reset runs view whenever the active filter changes
      this.viewMode = 'live';
      this.runsList = [];
      this.activeRun = null;
      this.runContacts = [];

      if (val === null) {
        this.$store.commit('frontdesk/set_odData', []);
      }
      if (val) {
        this.set_right_panel_tab('');
        this.changeRightPanelStatus(false);
      }
    },
    $route: {
    handler(to, from) {
       this.handleRouteChange(to);
    },
    immediate: true
    },
    current_contact() { this.openFilter = false; },// if new contact clicked close all filter
    isFilterApplied(val) {
      this.updateIsFilterApplied(val);
      if (!val) {
        this.changePanelToAll();
      }
    }
  },

  async created() {
    await this.$store.dispatch('frontdesk/loadOdFilters');
    await this.getTags;
    await this.getContactTypes;
    await this.retrieveCalls();
   setTimeout(() => {
      this.getContactfrom_OD();
    }, 0);
    // Fetch ongoing calls from backend and set in Vuex
    await this.$store.dispatch("plivo/fetchOngoingCalls");

    // Reload-persistence for due reminders: the live "reminderDue" push only
    // reaches a session that's already open when reminder-due-sync's tick
    // fires, so a fresh load/reload needs this read-path counterpart to show
    // the same badges (see getDueReminderContacts, convo.controller.js).
    try {
      const res = await ConvoService.getDueReminderContacts();
      const dueContacts = res?.data?.data || [];
      dueContacts.forEach(contact => {
        this.$store.commit("frontdesk/reminderDue", [contact]);
      });
    } catch (e) {
      console.error("Failed to load due reminders", e);
    }

    EventBus.$on("changeFrontDesk", async (data) => {

      this.hideThreads();
       // Access individual emitted properties
      const contact_id = data.contact_id;
      const itemType = data.type;
      const contact = this.contactsHash[contact_id];

      var call = { call_missed: null, comm_direction: null, date: null };

      if (itemType == "user") {
        this.isUser(true);
        this.change_contact({
          call_status: call.call_missed,
          comm_direction: call.comm_direction,
          contact_id: contact_id,
          date: call.date,
          first_name: contact_id,
          last_name: contact_id,
          phone_num: contact_id,
        });
        if (this.isMobile) { this.$emit('closeLeftPanel'); }
        await this.getConversations({ contact_id: contact_id });// for user
        EventBus.$emit("scroll-bottom");
       
      } else {
        this.isUser(false);
        this.change_contact({
          call_status: call.call_missed,
          comm_direction: call.comm_direction,
          contact_id: Number(contact_id),
          date: call.date,
          first_name: contact.first_name,
          last_name: contact.last_name,
          ph1: contact.ph1,
          ph2: contact.ph2,
          ph3: contact.ph3,
          email: contact.email,
          textable1: contact.textable1,
          textable2: contact.textable2,
          textable3: contact.textable3,
          tag_id: contact.tags
        });
        this.setContact(contact);
        this.updateRightPanel(contact_id);
        if (this.isMobile) { this.$emit('closeLeftPanel'); }
        await this.getConversations({ contact_id: contact_id });// for contact
        EventBus.$emit("scroll-bottom");
      }
     
    });
if (this.$route.path === "/frontdesk") {
  await this.$nextTick();
     setTimeout(() => {  
       this.filters = ["Unattended"];     
    this.onFilterChange(["Unattended"]);
    }, 1000);
  }
  },

  methods: {
   ...mapMutations('labcases', ['Setlabpagestatus']),
    ...mapMutations("frontdesk", ["setcontactconversationtag","change_contact", "changeLoading","setAllConversations","setlaboffset", "labdata", "set_left_panel_contacts","set_right_panel_tab", "setOdTag", "odSelected_value", "isUser", "unshiftAllConversations", "conversation_loading", "updateIsFilterApplied"]),
  ...mapMutations(["setContact"]),
  ...mapMutations("osclaims", ["changeClaim", "changeClaims", "changeProcess"]),
  ...mapActions("osclaims", ["retrieveClaims"]),
  ...mapMutations("convos", ["setInternalConvos"]),
  ...mapMutations(['changeRightPanelStatus']),
  ...mapActions("tags", ["applyMassTagforContact"]),
  ...mapGetters("plivo", ["getUserDictionary"]),
  ...mapActions("frontdesk", ["retrieveCalls","getODdata","hide", "getConversations","hideThreads","getconversationtag","searchConversation"]),
  // Method to calculate the count of items for a specific status
 statusCount(status) {
    return this.filterCalls.filter(call => {
  const statuses = this.contactStatus(call.contact_id);
  return statuses && statuses.includes(status);}).length;
  },
    joinOngoingCall(item) {
      this.selectedCall = item;
      this.showJoinCallDialog = true;
    },
  async open_Filter(){
     await this.closePanelToall();
     this.clearConversationTagFilter();
      if(this.openFilter){this.openFilter = false;}else{this.openFilter = true;}
    },
    async onFilterChange(activeFilters) {
       this.clearConversationTagFilter();
       this.$nextTick();
  console.log("Active Filters:", activeFilters);
if(activeFilters && activeFilters.length === 0){
 await this.closePanelToall();
     this.clearConversationTagFilter();
}
  this.type_selectedValues = [];
  this.tag_selectedValues = [];
  this.od_selectedValue = null;
  this.activeStatusFilter = null;
  this.clickedStatus = null;

  setTimeout(() => {
    this.Schedulefilter = true;
    EventBus.$emit("openlab_conversation", false);
  }, 0);

  // If user cleared the filter
  if (!activeFilters || activeFilters.length === 0) {
    this.closePanelToall(); // Use your reset logic
    return;
  }

  // Otherwise handle the new filter
  const hotLeadFilter = activeFilters.includes("Hot Leads");
  const Unattended = activeFilters.includes("Unattended");
  const isODFilter = activeFilters.some(f =>
    this.odFilterList.some(od => od.filter_name === f)
  );
if (Unattended && this.$route.path === '/frontdesk') {
  const unattendedTag = this.tags.find(
    t => t.tag_name === "Unattended"
  );
  if (!unattendedTag) {
    console.warn("Unattended tag not found");
    return;
  }

  this.conversationTagFilter = [unattendedTag.tag_id];

  this.$store.commit("frontdesk/set_odData", []);
  this.$store.commit("frontdesk/set_odDataHash", {});

  this.updateIsFilterApplied(true);
  await this.getconversationtag({
    tag_id: unattendedTag.tag_id,
    reset: true
  });

  this.set_left_panel_contacts(this.odData);
}else{
  this.conversationTagFilter =[]
}

  // Handle "Hot Leads"
  if (hotLeadFilter) {
    this.type_selectedValues = ["hotlead"];
    const selectedTypeData = this.type_selectedValues.flatMap(
      item => this.get_AllContact_Typesdata[item] || []
    );
    this.combinedData = [...new Set(selectedTypeData)];
    this.set_left_panel_contacts(this.combinedData);
    return;
  }

  // Handle OD filters
  if (isODFilter) {
    this.od_selectedValue = activeFilters[0];
    await this.getContactfrom_OD();
    this.set_left_panel_contacts(this.odData);
    if (this.od_selectedValue === "lab-cases" && this.Schedulefilter) {
      this.handleStatusClick(3);
    } else {
      this.handleStatusClick(null);
      this.Schedulefilter = false;
    }
  }
},

    // Toggle status filter: pass number 1..4, 0 = unknown, null to clear.
   async handleStatusClick(status) {
      if (status === null) {
        this.activeStatusFilter = null;
        return;
      }
      // Toggle: if same clicked again -> clear
     this.activeStatusFilter = this.activeStatusFilter === status ? null : status;
     this.clickedStatus = this.activeStatusFilter;
    },

    // Helper: return status number or null for a contact_id using odData
    contactStatus(contactId) {
      if (!this.odData || !Array.isArray(this.odData)) return null;
      const matched = this.odData.find(c => String(c.contact_id) === String(contactId));
      if (!matched || !Array.isArray(matched.od_json) || matched.od_json.length === 0) return null;
      const s = matched.od_json.map(obj => Number(obj.status));
      return s.length ? s : null;
    },

    async joinOngoingCallAsSupervisor() {
      try {
        if (!this.selectedCall) throw new Error('No call selected');
        if (!this.selectedCall.conferenceName) throw new Error('ConferenceName is not specified');

        let plivoSipHeaders = {
          "X-Ph-Calleruserid": this.userId,
          "X-Ph-Conferencename": this.selectedCall.conferenceName
        };
        this.plivoBrowserSdk.client.call('1123456789', plivoSipHeaders);

        this.showJoinCallDialog = false;
        this.selectedCall = null;
      } catch (err) {
        console.error("Error joining ongoing conference:", err);
        this.$store.dispatch('showError', 'Failed to join conference call');
      }
    },
 statusColorClass(status) {
    switch (status) {
      case 1: return "orange darken-2";
      case 2: return "blue darken-2";
      case 3: return "green darken-2";
      case 4: return "teal darken-2";
      default: return "grey darken-1";
    }
  },
    async toggleAIValidation() {
      this.showAIValidation = !this.showAIValidation;
      if (this.showAIValidation) {
        await this.closePanelToall();
        this.changeLoading(true);
        try {
          const { data } = await aiValidationService.getContacts();
          this.set_left_panel_contacts(data);
        } catch (e) {
          console.error('AI contacts fetch failed', e);
        } finally {
          this.changeLoading(false);
        }
      } else {
        this.set_left_panel_contacts(this.fd_contacts);
      }
    },
    async selectContact(contact_id, item) {
      if (contact_id === 'users') return;
      this.hideThreads();
      this.isUser(false);
      EventBus.$emit("openlab_conversation", false);
      EventBus.$emit("showRightPanel", true);
      if (this.enable_selection) {
        if (this.selected_contacts.includes(contact_id)) {
          // Remove id if already selected
          this.selected_contacts = this.selected_contacts.filter((id) => id !== contact_id);
        } else {
           // Add id if not selected
          this.selected_contacts.push(contact_id);
        }
      } else {
        this.change_contact({
          call_status: item.call_status,
          comm_direction: item.comm_direction,
          contact_id: Number(item.contact_id),
          date: item.date,
          first_name: item.first_name,
          last_name: item.last_name,
          ph1: item.ph1,
          ph2: item.ph2,
          ph3: item.ph3,
          textable1: item.textable1,
          textable2: item.textable2,
          textable3: item.textable3,
          email : item.email,
          tag_id: item.tag_id,
          conversationstags:item?.conversationstags || null
        });
        if(item.conversationstags){
  this.setcontactconversationtag(item.conversationstags);
        }
        let contact = this.contactsHash[Number(item.contact_id)];
        this.setContact(contact);
        this.updateRightPanel(contact_id);
        if(this.od_selectedValue ==='lab-cases' ){
          setTimeout(() => {
           this.changeRightPanelStatus(true);
          this.set_right_panel_tab('lab-cases');
          },0);
        }else if(this.od_selectedValue ==='Un-ConfirmedAppointment'){
          setTimeout(() => {
            this.changeRightPanelStatus(true);
            this.set_right_panel_tab("appointments");
          },0);
        }else if(this.od_selectedValue ==='Pre-Auths'){
          setTimeout(() => {
            this.changeRightPanelStatus(true);
            this.set_right_panel_tab("PreAuthsDetails");//PreAuthsDetails
          },0);      
        }else if (this.od_selectedValue ==='Pending-Treatment'){
          setTimeout(() =>{
            this.changeRightPanelStatus(true);
            this.set_right_panel_tab("pendingTreatmentDetails")
          },0)
        }
        EventBus.$emit("closeinternallabdata");
        if (this.isMobile) { this.$emit('changePanel'); }
        await this.getConversations({ contact_id: contact_id });
        EventBus.$emit("scroll-bottom");
      }
    },

    selectAllContacts() {
      this.select_AllContacts = !this.select_AllContacts;
      if (this.selected_contacts.length === this.left_panel_contacts.length && !this.select_AllContacts) {
        this.selected_contacts = [];
      } else if (this.select_AllContacts) {
        this.selected_contacts = this.left_panel_contacts.map((contact) => contact.contact_id);
      }
    },
    // lazy loading only for od filter
   async handleScroll(event) {
      const scroller = event.target;
      const { scrollTop, scrollHeight, clientHeight } = scroller;
      this.isBottom = scrollTop + clientHeight >= scrollHeight - 1;
      // if we reached bottom of the scroller we are calling next offset of OD data
      if (this.isBottom) {
        if( this.conversationTagFilter.length !==0 && this.$route.path === '/frontdesk'){
          await this.getconversationtag({tag_id:this.conversationTagFilter[0]});
        }else if (this.isFilterApplied && this.od_selectedValue && !this.loading) {
          this.getContactfrom_OD(true);
        }
        
      }
    },

    getTagNames(tagIds) {
      let tagNames = [];
      for (let tagId of tagIds) {
        let tagName = this.tagsHash[tagId];
        if (tagName) tagNames.push(tagName);
      }
      return tagNames;
    },
  async closePanelToall() {
  this.changePanelToAll();
  this.clearConversationTagFilter();
  this.filters = [];     
  this.selectedCarrier = [];
  this.carrierList = [];
  this.showPreAuthFilter = false;
},

    changePanelToAll() {
     
      this.set_left_panel_contacts(this.fd_contacts);
      this.tag_selectedValues = [];
      this.type_selectedValues = [];
      this.od_selectedValue = null;
      this.searchTerm = "";
      this.$store.commit('frontdesk/set_odData', null);
      this.openFilter = false;
      this.enable_selection = false;
      this.selected_contacts = [];
      this.setOdTag(null);
      this.odSelected_value(null);
      this.activeStatusFilter = null; 
      this.labdata(true);
      this.changeRightPanelStatus(false);
      this.selectedLabs =null;
      this.hasLabNameFilter = false;
      this.labs = [];
      this.selectedLab = [];
      this.selectedStatus = [];
      this.expanded = false;
      this.setlaboffset(0);
      this.clickedStatus = null;
      EventBus.$emit("openlab_conversation", false);
      this.Schedulefilter=false;
    },
  //   filterPreAuth() {
  // this.updateCall += 1;
  //   },
    expand() {  this.expanded = true;},
    async changePanelToTOday() {
       // this.panel = 1;
         console.log("Panel changed to TODAY");
      this.set_left_panel_contacts(this.fd_contacts);
      const convos = await ConvoService.getClientInternalConvosToday();
      const filteredCalls = this.fd_contacts.filter(call => convos.data.some(convo => convo.contact_id === call.contact_id));// Check if any convo in convos.data has a matching contact_id in convo_references
      this.set_left_panel_contacts(filteredCalls);
      this.changeRightPanelStatus(true);
      EventBus.$emit("populateRightPanel1");
       this.expanded = false;
    }, 

    async changePanelToLater() {
       // this.panel = 2;
      console.log("Panel changed to LATER");
      this.set_left_panel_contacts(this.fd_contacts);
      const convos = await ConvoService.getClientInternalConvosLater();
      const filteredCalls = this.fd_contacts.filter(call => convos.data.some(convo => convo.contact_id === call.contact_id)); // Check if any convo in convos.data has a matching contact_id in convo_references
      this.set_left_panel_contacts(filteredCalls);
      this.changeRightPanelStatus(true);
      EventBus.$emit("populateRightPanel1");
      this.expanded = false;
    },

    phoneFormat,
    //union filter
    filter_handle() {
      setTimeout(() => {
      this.Schedulefilter=false;
      }, 0);
      let combinedSet = new Set();

      // Filter type_selectedValues
      if (this.type_selectedValues.length !== 0) {
        let selectedTypeData = this.type_selectedValues.flatMap(item => this.get_AllContact_Typesdata[item] || []);
        selectedTypeData.forEach(id => combinedSet.add(id));
      }

      // Filter tag_selectedValues
      if (this.tag_selectedValues.length !== 0) {
        let selectedTagData = Object.keys(this.get_alltags_data).filter(key => this.tag_selectedValues.includes(key)).flatMap(key => this.get_alltags_data[key] || []);
        selectedTagData.forEach(id => combinedSet.add(id));
      }

      // If no filters are selected it will show all left_panel_contacts
      if (this.type_selectedValues.length === 0 && this.tag_selectedValues.length === 0) {
        this.set_left_panel_contacts(this.fd_contacts);
        return;
      }

      // Convert the Set to an array 
      this.combinedData = Array.from(combinedSet);
      this.set_left_panel_contacts(this.combinedData);
    },
async onConversationTagFilter(tagIds) {
        if (!tagIds || tagIds.length === 0) {
              this.clearConversationTagFilter();
          return;
        }

        this.closePanelToall();
      const latestTagId = tagIds[tagIds.length - 1];

        // Force v-model to contain only one tag
        this.conversationTagFilter = [latestTagId];

        // Reset existing data
        this.$store.commit("frontdesk/set_odData", []);
        this.$store.commit("frontdesk/set_odDataHash", {});

        // Fetch data for the selected tag
        await this.getconversationtag({
        tag_id: latestTagId,
          reset: true
        });
        // Show results in left panel
        this.set_left_panel_contacts(this.odData);
      },
 clearConversationTagFilter() {
    this.conversationTagFilter = [];

    // reset Vuex conversation-tag state
    this.$store.commit("frontdesk/set_odData", []);
    this.$store.commit("frontdesk/set_odDataHash", {});
    this.$store.commit("frontdesk/setcontactconversationtag", []);
    this.$store.commit("frontdesk/setshowconversationtagarrow", false);
    this.$store.commit("frontdesk/setOdHasMore", true);
    this.$store.commit("frontdesk/odSelected_value", null);

    // restore default FD contacts

    this.$store.commit(
      "frontdesk/set_left_panel_contacts",
      this.$store.state.frontdesk.fd_contacts
    );
  },
    // ── Campaign Runs view ─────────────────────────────────────────────────
    toggleRunsView() {
      if (this.viewMode !== 'live') {
        this.viewMode = 'live';
      } else {
        this.viewMode = 'runs';
        this.loadRuns();
      }
    },

    async loadRuns() {
      if (!this.activeODFilterId) return;
      this.runsLoading = true;
      this.runsList = [];
      try {
        const res = await OdService.getFilterRuns(this.activeODFilterId);
        this.runsList = res?.data?.data || [];
      } catch (e) {
        console.error('loadRuns failed', e);
      } finally {
        this.runsLoading = false;
      }
    },

    async openRun(run) {
      this.activeRun = run;
      this.viewMode = 'runDetail';
      this.runContactsLoading = true;
      this.runContacts = [];
      try {
        const res = await OdService.getFilterRunContacts(this.activeODFilterId, run.execution_id);
        this.runContacts = res?.data?.data || [];
      } catch (e) {
        console.error('openRun failed', e);
      } finally {
        this.runContactsLoading = false;
      }
    },

    backToRuns() {
      this.viewMode = 'runs';
      this.activeRun = null;
      this.runContacts = [];
    },

    async openRunSnapshot(run) {
      this.snapshotDialog = true;
      this.snapshotLoading = true;
      this.runSnapshot = null;
      try {
        const res = await OdService.getFilterRunSnapshot(this.activeODFilterId, run.execution_id);
        this.runSnapshot = res?.data?.data || null;
      } catch (e) {
        console.error('openRunSnapshot failed', e);
      } finally {
        this.snapshotLoading = false;
      }
    },

    snapshotTagName(tagId) {
      if (!tagId) return null;
      return this.tags.find(t => t.tag_id === tagId)?.tag_name || null;
    },

    snapshotScheduleDescription(cfg) {
      if (!cfg) return 'Not scheduled';
      return cfg.description || (cfg.scheduleType === 2 ? 'Recurring' : 'One-time send');
    },

    async getContactfrom_OD(isLoadMore = false) {
      if (this.od_selectedValue) {
        if(this.od_selectedValue != 'lab-cases') {
          this.selectedLabs =null;
        }
        let ind = this.tags.findIndex(tag =>
          tag.tag_name.replace(/\s+/g, "").toLowerCase() === this.od_selectedValue.replace(/\s+/g, "").toLowerCase());// searching corresponding tag
        this.setOdTag(ind >= 0 ? this.tags[ind] : null);
        this.set_left_panel_contacts(this.odData);
        await this.getODdata({ filterName: this.od_selectedValue, isLoadMore });
        this.set_left_panel_contacts(this.odData);
      if (this.od_selectedValue === "Pre-Auths") {

        let carriers = new Set();

        // From OD JSON
        (this.odData || []).forEach(c => {
          if (Array.isArray(c.od_json)) {
            c.od_json.forEach(j => {
              if (j.CarrierName) carriers.add(j.CarrierName);
            });
          }
        });

        // From osclaims Vuex store
        (this.claims || []).forEach(claim => {
          if (claim.Carrier) carriers.add(claim.Carrier);
        });

        this.carrierList = Array.from(carriers);

      } else {
        this.showPreAuthFilter = false;
        this.selectedCarrier = [];
      }
      } else {
        this.$store.commit('frontdesk/odSelected_value', null);
        this.set_left_panel_contacts(this.fd_contacts);
      }
    },

    getstatus(contact) {
      const matched = this.odData.find(c => c.contact_id === contact);
      if (matched && Array.isArray(matched.od_json) && matched.od_json.length > 0) {
        let status = matched.od_json[0].status;
        switch (status) {
          case 1: return "orange darken-2";
          case 2: return "blue darken-2";
          case 3: return "green darken-2";
          case 4: return "teal darken-2";
          default: return "grey lighten-1";
        }
      }
      return "grey lighten-1";
    },

    getStatusIcon(contact) {
      const matched = this.odData.find(c => c.contact_id === contact);
      if (matched && Array.isArray(matched.od_json) && matched.od_json.length > 0) {
        let status = matched.od_json[0].status;
        switch (status) {
          case 1: return "mdi-clipboard-text-off-outline";
          case 2: return "mdi-truck-delivery-outline";
          case 3: return "mdi-email-arrow-left-outline";
          case 4: return "mdi-calendar-range";
          default: return "mdi-help-circle-outline";
        }
      }
      return "mdi-help-circle-outline";
    },

    toggleApplyMassTag() {
      this.enable_selection = !this.enable_selection;
      this.selected_contacts = [];
      this.selectedTags = [];
      this.select_AllContacts = false;
      this.openFilter = false;
    },

    getStatusValue(status) {
      switch (String(status)) {
        case "1": return "Created";
        case "2": return "Sent";
        case "3": return "Received";
        case "4": return "Appointment Scheduled";
        default: return "Status Unknown";
      }
    },

       calcTooltip(item) {
      if (this.od_selectedValue ==='lab-cases' && item.od_json) {
        let newstatus = item?.od_json[0]?.status || null;
        return this.getStatusValue(newstatus);
      }else if (item.od_json) return this.od_selectedValue;
       else if (item.call_status === 1 || item.call_missed === 1) return "Call Missed";
      else if (item.call_status === 3 || item.call_missed === 3) return "On Going";
      else if (item.comm_direction === 'outbound') return "Call Made";
      else if (!item.comm_direction || item.comm_direction === 'incoming') return "Message Received";
      else if (!item.comm_direction || item.comm_direction === 'outgoing' || item.comm_direction === 'queued' || item.comm_direction === 'delivered') return "Message Sent";
      else if (!item.comm_direction || (item.comm_direction == 'failed' || item.comm_direction === 'undelivered' || item.comm_direction === 'rejected')) return "Message Sending Failed";
      else if(item.comm_direction == 'received') return "Received Email";
      else if(item.comm_direction == 'sent') return "Sent Email";
      else return "Call Received";
    },

    campaignTooltip(item) {
      const parts = [];
      if (item.booked_at) {
        const apptDate = item.appt_date ? new Date(Number(item.appt_date)).toLocaleDateString() : null;
        parts.push(`Booked${apptDate ? `: ${apptDate}` : ''}`);
      }
      if (Array.isArray(item.channels) && item.channels.length) {
        parts.push(item.channels
          .map(ch => {
            const channelName = ch.channel === 'email' ? 'Email' : 'SMS';
            const status = ch.status === 'failed' ? 'failed' : 'sent';
            const opened = ch.opened_at ? ' (opened)' : '';
            return `${channelName}: ${status}${opened}`;
          })
          .join(' · '));
      }
      return parts.length ? parts.join(' · ') : "Campaign contact";
    },

    reminderTooltip(item) {
      if (!item.reminder_date) return "Reminder due";
      return `Reminder due: ${new Date(item.reminder_date).toLocaleString()}`;
    },

    formattedName(item) {
      const formatted = phoneFormat(item.first_name);
      return formatted === item.first_name ? (item.first_name + " " + (item.last_name || "")) : formatted;
    },

    async updateRightPanel(contact_id) {
      EventBus.$emit("update-InternalConvos", contact_id);
    },

    phoneCall(name, number) {
      let tagId = 0;
      if (this.odFilterSelectedValue && this.getOdTag && this.getOdTag.enable_auto && this.isODFilterContact(this.current_contact.contact_id)) {
        tagId = this.getOdTag.tag_id;// sending tag_id for conversation auto tag 
      }
      EventBus.$emit("call-event", { name, number, tagId });
    },

    textSearch(inputCalls) {
      if (!this.searchTerm || this.searchTerm === "") return inputCalls;

      var searchTerm = this.searchTerm.toLowerCase();
      let filteredcalls = [];
      for (let c in inputCalls) {
        let item = inputCalls[c];
        if (item.ph1 && item.ph1.includes(searchTerm)) { filteredcalls.push(item); continue; }
        if (item.ph2 && item.ph2.includes(searchTerm)) { filteredcalls.push(item); continue; }
        if (item.ph3 && item.ph3.includes(searchTerm)) { filteredcalls.push(item); continue; }

        if (item.first_name && item.last_name) {
          let record_fullName = item.first_name.toLowerCase() + " " + item.last_name.toLowerCase();
          if (item.first_name.toLowerCase().includes(searchTerm) || item.last_name.toLowerCase().includes(searchTerm) || record_fullName.includes(searchTerm))
            filteredcalls.push(item);
        }
      }
      return filteredcalls;
    },

    async applyMassTag(tag_ids) {
      const payload = { contact_ids: this.selected_contacts, tag_ids: tag_ids, message: '' };
      try {
        await this.applyMassTagforContact(payload);
      } catch (error) {
        console.error(error);
      } finally {
        this.selected_contacts = [];
        this.enable_selection = false;
      }
    },

    aiClicked() {
      this.$store.commit('frontdesk/change_contact', {});
      this.$store.commit('frontdesk/setAllConversations', []);
    },

    formatDirection(direction) {
      const directions = {
        'inbound': 'Inbound',
        'outbound': 'Outbound',
        'intConf': 'Internal Conference',
        'ibConCal': 'Internal Call',
        'ongoing': 'Ongoing Conference'
      };
      return directions[direction] || direction;
    },// end of method

    // Utility: button class for active status styling
    statusButtonClass(status) {
      const isActive = (status === 0 && this.activeStatusFilter === 0) || this.activeStatusFilter === status;
      return {
        'status-btn': true,
        'status-active': isActive
      };
    },
  applyLabFilter(selectedLabs) {
     if(this.od_selectedValue === 'lab-cases') {
    this.selectedLabs = selectedLabs;
        }else{
          this.selectedLabs =null;
        }
  },
    async loadLabs() {
     if (this.loadingLabs) return;
     if (this.hasLabNameFilter) return;
  this.loadingLabs = true;
    try {
      const res = await OdService.labnamelist();
    if (res.status >= 400) {
      console.error("API error:", res.status);
      this.hasLabNameFilter = false; 
      return;
    }
    this.hasLabNameFilter = true; 
     const newLabs = res.data;
  if (!Array.isArray(newLabs) || newLabs.length === 0) {
        this.loadingLabs = false;
        return;
      }
    this.labs=newLabs;
  } catch (err) {
    console.error("Error fetching labs:", err);
    this.hasLabNameFilter = false; 
  } finally {
    this.loadingLabs = false;
  }
},
getLeftPanelIcon(item) {
  // Ongoing call (highest priority)
  if (item.isOngoing) {
    return { icon: "mdi-phone-in-talk", color: "green" };
  }

  //  Missed call
  if (item.call_missed === 1) {
    return { icon: "mdi-phone-missed", color: "red" };
  }

  // Incoming / outgoing calls
  if (item.channel === "call") {
    if (item.comm_direction === "incoming") {
      return { icon: "mdi-phone-incoming", color: "blue" };
    }
    if (item.comm_direction === "outgoing") {
      return { icon: "mdi-phone-outgoing", color: "blue" };
    }
  }

  //  Messages
  if (item.channel === "text") {
    return {
      icon: "mdi-message-outline",
      color: item.comm_direction === "incoming" ? "red" : "blue"
    };
  }

  //  Emails
  if (item.channel === "email") {
    return {
      icon: "mdi-email-outline",
      color: item.comm_direction === "incoming" ? "red" : "blue"
    };
  }

  return null;
},
labcasesfilterpage() {
  this.type_selectedValues = [];
  this.tag_selectedValues = [];
  this.activeStatusFilter = null;
  this.clickedStatus = null;
  this.od_selectedValue = "lab-cases";  
  this.getContactfrom_OD();
}, 
 handleRouteChange(to) {
  setTimeout(() => {
    if (to.path === '/frontdesk') {
      this.Setlabpagestatus(false);
      this.closePanelToall();
    } else if (to.path === '/labCases') {
      this.Setlabpagestatus(true);
      EventBus.$emit("openlab_conversation", false);
      this.labcasesfilterpage();
    } else {
      console.error('No matching route condition');
    }
  }, 300);
},

  // onScroll(e) {
  //   const el = e.target;
  //   if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
  //     this.loadLabs();
  //   }
  // },
  filterLabs(selected) {
    this.selectedLab = selected;
    this.applyLabFilter(
      this.selectedLab.map(num => this.labs.find(l => l.lab_number === num))
    );
  },
  removeLabChip(value) {
    this.selectedLab = this.selectedLab.filter(v => v !== value);
    this.filterLabs(this.selectedLab);
  },
  getlabconversation(){
      this.changeProcess("Lab Conversation");
      EventBus.$emit('process', "Lab Conversation");
      this.retrieveClaims("Lab Conversation");
       EventBus.$emit("showRightPanel", false);
      setTimeout(() => {
         EventBus.$emit("openlab_conversation", true);
         if (this.isMobile) { this.$emit('closeLeftPanel'); }
          },500);
  }
},
  mounted() {
    this.handleRouteChange(this.$route);
    EventBus.$on("CloseFilter", () => { this.openFilter = false; });// Ongoing calls are now updated via WebSocket and Vuex
  //  EventBus.$on("update-call", () => { this.updateCall += 1; });// when call is updated we are incrementing this value to trigger re-render of left panel
    //  when we update key it will re-render the left panel

  },

  beforeUnmount() {
    this.$store.commit('frontdesk/change_contact', {});
    this.$store.commit('frontdesk/setAllConversations', []);
    this.$store.commit('frontdesk/set_odData', []);
    EventBus.$off("changeFrontDesk");
    EventBus.$off("CloseFilter");
  },
};
</script>

<style scoped>
.shared-overlay {
  position: absolute;
  margin-top: 20%;
  left: 100%;
  transform: translate(-10%, -10%);
  z-index: 2;
  width: 100%;
  height: 100%;
}
.shared-overlay-mobile {
  position: absolute;
  margin-top: 20%;
  left: 50%;
  transform: translate(-10%, -10%);
  z-index: 2;
  width: 100%;
  height: 100%;
}

.mass-tag-mobile { position: absolute; margin-top: -15%; margin-left: -15%; }
.mass-tag-window { position: absolute; margin-top: -30%; margin-left: -30%; }

.ongoing-call {
  background-color: rgba(76, 175, 80, 0.1);
  border-left: 3px solid #4CAF50;
  margin: 0;
}

.ongoing-calls-header {
  color: #2E7D32;
  font-weight: 500;
  display: flex;
  align-items: center;
  background-color: rgba(76, 175, 80, 0.15);
  border-left: 3px solid #4CAF50;
  border-bottom: 1px solid rgba(76, 175, 80, 0.2);
}

/* AI Validation List */
.ai-val-item {
  padding: 6px 10px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ai-val-item:hover { background: #f8fafc; }
.ai-val-main { display: flex; justify-content: space-between; align-items: center; }
.ai-val-name { font-size: 13px; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 120px; }
.ai-val-phone { font-size: 11px; color: #94a3b8; }
.ai-val-meta { display: flex; justify-content: space-between; align-items: center; gap: 6px; }
.ai-val-time { font-size: 11px; color: #6366f1; white-space: nowrap; }

.status-btn {
  margin: 5px;
  border: solid 1px black;
  height: fit-content;
  border-radius: 7px;
  padding: 6px;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.status-active {
  background: rgba(33, 150, 243, 0.08); 
  box-shadow: 0 0 0 2px rgba(33,150,243,0.06) inset;
}
.status-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: rgb(255, 255, 255);  
  color: rgb(7, 7, 7);             
  border: 2px solid rgb(0, 0, 0);  
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: bold;
  min-width: 20px;
  text-align: center;
}
.action-buttons-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.action-buttons-wrapper {
  display: flex;
  align-items: center;
  gap: 0px;
  width: 100%;
}

.action-button {
  display: flex;
  justify-content: center;
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-button:hover {
  background: #f5f5f5;
  border-color: #bbbbbb;
}

.action-button.active {
  background: #e8f5e9;
  border-color: #4caf50;
}

.scheduling-filter {
  flex: 1;
  max-width: 200px;
}

.action-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.action-container button {
  font-size: 12px;
  display: none;
  border: 1px solid #000;  
  border-radius: 6px;
  padding: 4px 6px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-container button:first-child {
  display: block;
}

.action-container:hover button {
  display: block; 
}

.action-container button:hover {
  border-color: #1976d2;
  background: #f5f5f5;
}
.group:hover .absolute {
  display: flex !important;
}
.filter-chip-truncated {
  max-width: 240px;
  min-width:fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 16px;
}

.chip-item {
  background-color: #e3e3e3;
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
}

.extra-count {
  font-weight: bold;
  color: #1976d2;
  margin-right: 4px;
}

.pulse-icon {
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.3); }
  100% { transform: scale(1); }
}

</style>